import React from 'react';

import { LexxyEditor } from './lexxy_editor';

export type HTMLFormControlProps = {
  id?: string;
  name?: string;
  value: string;
  onChange(value: string): void;
};

export const HTMLFormControl: React.FC<HTMLFormControlProps> = ({ id, name, value, onChange }) => {
  return <LexxyEditor id={id} name={name} value={value} onChange={onChange} />;
};
